// Tabs/TabPanelContent.baskets.tsx
import React from 'react';
import AllBaskets from '../components/tabs/basket/AllBaskets';


const TabPanelContentBaskets: React.FC = () => (
    <div className="row">
        <div className="col-12 col-sm-12">
            <AllBaskets />
        </div>
    </div>
);

export default TabPanelContentBaskets;
